function ServiceModal({ service, onClose }) {
  if (!service) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-brand-text/45 px-5 py-8">
      <div className="w-full max-w-2xl rounded-3xl bg-white p-7 shadow-bloom sm:p-8">
        <div className="mb-6 flex items-start justify-between gap-4">
          <h3 className="text-4xl text-brand-text">{service.title}</h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full border border-brand-petal px-4 py-1.5 text-sm font-semibold text-brand-primary transition hover:bg-brand-mist"
          >
            Close
          </button>
        </div>

        <div className="space-y-5 text-brand-text/90">
          <section>
            <h4 className="text-xl text-brand-deep">About the Service</h4>
            <p className="mt-2 leading-7">{service.modal.about}</p>
          </section>

          <section>
            <h4 className="text-xl text-brand-deep">Our Process</h4>
            <ul className="mt-2 list-disc space-y-1 pl-5 leading-7">
              {service.modal.process.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h4 className="text-xl text-brand-deep">Aftercare</h4>
            <ul className="mt-2 list-disc space-y-1 pl-5 leading-7">
              {service.modal.aftercare.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>

          <section>
            <h4 className="text-xl text-brand-deep">Recommendations</h4>
            <p className="mt-2 leading-7">{service.modal.recommendations}</p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default ServiceModal;